export default __webpack_public_path__ + "static/media/ratifikaLogo.4e3c476b.svg";